<div class="performance-chart">
  <ng-container *ngIf="hasActivity; else noActivity">
    <svg
      class="performance-chart-svg"
      viewBox="-64 0 724 238"
      preserveAspectRatio="xMidYMid meet"
      role="img"
      [attr.aria-label]="'dashboard_chart_aria_label' | translate"
    >
      <title>{{ 'dashboard_chart_aria_label' | translate }}</title>

      <ng-container *ngFor="let tick of valueTicks">
        <line class="grid-line" x1="0" [attr.y1]="tick.y" x2="640" [attr.y2]="tick.y"></line>
        <text class="axis-label" x="-10" [attr.y]="tick.y + 4" text-anchor="end">
          {{ tick.label }}
        </text>
      </ng-container>

      <ng-container *ngFor="let point of chartPoints">
        <rect
          class="sales-bar"
          [attr.x]="point.barX"
          [attr.y]="point.barY"
          [attr.width]="point.barWidth"
          [attr.height]="point.barHeight"
          rx="5"
        >
          <title>
            {{ point.date }}: {{ point.formattedValue }},
            {{ point.receivedOrderCount }} {{ 'dashboard_chart_received_orders' | translate }}
          </title>
        </rect>
        <text
          *ngIf="point.showDateLabel"
          class="date-label"
          [attr.x]="point.centerX"
          y="216"
          text-anchor="middle"
        >
          {{ point.dateLabel }}
        </text>
      </ng-container>

      <polyline
        *ngIf="orderLinePoints"
        class="orders-line"
        [attr.points]="orderLinePoints"
        fill="none"
      ></polyline>
      <ng-container *ngFor="let point of chartPoints">
        <circle class="orders-point" [attr.cx]="point.centerX" [attr.cy]="point.orderY" r="4">
          <title>
            {{ point.date }}: {{ point.receivedOrderCount }}
            {{ 'dashboard_chart_received_orders' | translate }}
          </title>
        </circle>
      </ng-container>
    </svg>

    <div class="chart-legend" aria-hidden="true">
      <span class="legend-item">
        <span class="legend-swatch sales"></span>
        {{ 'dashboard_chart_completed_value' | translate }}
      </span>
      <span class="legend-item">
        <span class="legend-swatch orders"></span>
        {{ 'dashboard_chart_received_orders' | translate }}
      </span>
    </div>

    <ul class="screen-reader-series">
      <li *ngFor="let point of chartPoints">
        {{ point.date }}: {{ point.formattedValue }}, {{ point.receivedOrderCount }}
        {{ 'dashboard_chart_received_orders' | translate }}
      </li>
    </ul>
  </ng-container>

  <ng-template #noActivity>
    <div class="chart-empty-state">
      <mat-icon>insights</mat-icon>
      <div>
        <strong>{{ 'dashboard_chart_empty_title' | translate }}</strong>
        <span>{{ 'dashboard_chart_empty_description' | translate }}</span>
      </div>
    </div>
  </ng-template>
</div>
